// Card definitions and helpers for the shoe.

export const SUITS = [
  { id: "spades", symbol: "\u2660", label: "Spades", color: "black" },
  { id: "hearts", symbol: "\u2665", label: "Hearts", color: "red" },
  { id: "diamonds", symbol: "\u2666", label: "Diamonds", color: "red" },
  { id: "clubs", symbol: "\u2663", label: "Clubs", color: "black" },
];

export const RANKS = ["A", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K"];

export const cardId = (suit, rank) => `${suit}-${rank}`;

// Hi-Lo running count value for a rank.
export function hiLoValue(rank) {
  if (["2", "3", "4", "5", "6"].includes(rank)) return 1;
  if (["7", "8", "9"].includes(rank)) return 0;
  return -1; // 10, J, Q, K, A
}

// Build a fresh shoe: every suit/rank has `deckCount` copies remaining.
export function buildShoe(deckCount) {
  const counts = {};
  for (const suit of SUITS) {
    for (const rank of RANKS) {
      counts[cardId(suit.id, rank)] = deckCount;
    }
  }
  return counts;
}

export const TOTAL_CARDS_PER_DECK = SUITS.length * RANKS.length; // 52
